module.exports = __webpack_public_path__ + "img/product.3ad1ce62.svg";